// Trinova theme.js — minimal, robust
(function(){
  'use strict';

  // ===== Theme toggle =====
  document.querySelectorAll('[data-theme-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var c = document.documentElement.getAttribute('data-theme') || 'light';
      var n = c === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', n);
      try { localStorage.setItem('theme', n); localStorage.setItem('theme-manual', '1'); } catch(e){}
    });
  });

  // ===== Locale switcher =====
  document.querySelectorAll('[data-lang]').forEach(function(sw){
    var btn = sw.querySelector('[data-lang-btn]');
    if(!btn) return;
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      sw.classList.toggle('is-open');
    });
    document.addEventListener('click', function(e){
      if(!sw.contains(e.target)) sw.classList.remove('is-open');
    });
  });

  // ===== Drawer (cart, menu) =====
  document.querySelectorAll('[data-drawer-open]').forEach(function(b){
    b.addEventListener('click', function(){
      var id = b.getAttribute('data-drawer-open');
      var d = document.getElementById(id);
      if(d){ d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-drawer-close], .drawer__overlay').forEach(function(b){
    b.addEventListener('click', function(){
      var d = b.closest('.drawer');
      if(d){ d.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      document.querySelectorAll('.drawer.is-open').forEach(function(d){ d.classList.remove('is-open'); });
      document.body.style.overflow = '';
    }
  });

  // ===== Header scroll =====
  var header = document.querySelector('[data-header]');
  if(header){
    var update = function(){ header.classList.toggle('is-scrolled', window.scrollY > 4); };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  // ===== Cart count refresh =====
  function fmtMoney(cents){
    return (cents/100).toLocaleString(undefined, { style:'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }
  window.refreshCartCount = function(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = c.item_count;
        if(c.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden','');
      });
    });
  };

  // ===== Add to cart (AJAX on product page) =====
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      // Only intercept if has data-ajax (otherwise let default submission happen for safety)
      if(!form.hasAttribute('data-ajax')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if(btn){ btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      fetch(window.routes.cart_add_url + '.js', {
        method:'POST', body: new FormData(form),
        headers: { 'Accept':'application/javascript' }
      }).then(function(r){ return r.json(); }).then(function(){
        if(btn){ btn.textContent = 'Added ✓'; setTimeout(function(){ btn.textContent = btn.dataset.label; btn.disabled = false; }, 1400); }
        window.refreshCartCount();
      }).catch(function(){
        if(btn){ btn.textContent = btn.dataset.label; btn.disabled = false; }
      });
    });
  });

  // ===== Variant picker (product page) =====
  document.querySelectorAll('[data-variant-picker]').forEach(function(picker){
    var form = picker.closest('form');
    var variants = JSON.parse(picker.getAttribute('data-variants') || '[]');
    var hidden = form && form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var btn = form && form.querySelector('[type="submit"]');

    function update(){
      var selected = [];
      picker.querySelectorAll('.product__opt').forEach(function(opt){
        var checked = opt.querySelector('input:checked');
        if(checked) selected.push(checked.value);
      });
      var match = variants.find(function(v){ return v.options.every(function(o,i){ return o === selected[i]; }); });
      if(!match) return;
      if(hidden) hidden.value = match.id;
      if(priceEl){
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<s>' + fmtMoney(match.compare_at_price) + '</s> ' + fmtMoney(match.price)
          : fmtMoney(match.price);
      }
      if(btn){
        if(match.available){ btn.disabled = false; btn.textContent = btn.dataset.addLabel || 'Add to bag'; }
        else { btn.disabled = true; btn.textContent = 'Sold out'; }
      }
    }
    picker.addEventListener('change', update);
    update();
  });
})();
